import apiUrl from '../../../../constants';
import axios from 'axios';
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';

export default {
    name: 'DayEndClosureLogs',
    components: {
		VueElementLoading
	},
    props: {
      shippingId: {
        type: String,
        required: true
      }
    },
    data: function() {
		return {
			barcode:'',
			shipmentData:[],
			isLoading: false,
			showTable:false,
			processLocationHubIds: [],
			updatedShipmentData: [],
		}
	},
    created() {
      console.log('DayEndClosureLogs - Shipping ID:', this.shippingId);
      // You can fetch logs here using this.shippingId
    },
    model: {
    },
    computed: {
    },
    filters: {
        moment: function(date) {
            if (date == null || date == '')
                return '--'
            return moment(date).format('DD-MM-YYYY HH:mm:ss');
        }
    },
    mounted() {
        this.$refs.barcode.focus();
        if (this.shippingId) {
            this.barcode = this.shippingId;
            this.showdetails();
        }
    },
    methods: {
		resetData(){
			this.barcode='',
			this.shipmentData='',
			this.showTable=false,
			this.isLoading=false,
			this.updatedShipmentData = [],
			this.processLocationHubIds = [],
			this.shipmentData = [],
			this.$refs.barcode.focus(),
			this.$validator.reset();
            this.errors.clear();
		},

		showdetails(){
			this.$validator.validateAll().then((result) => {
                if (result) {
					this.shipmentData=[];
					this.processLocationHubIds = [];
					this.updatedShipmentData = [];
					this.showTable=false; this.isLoading=true;
					axios({
							method: 'GET',
							url: apiUrl.api_url_hubops + 'getDayEndClosureLogs' + "?shippingId=" + this.barcode,
							headers: {
								'authorization': 'authkey xB84JJ89Hd25',

							}
						})
						.then(result => {
							this.showTable=true;
							if (result.data.ResultCode == 100) {
								this.shipmentData=result.data.ResponseData;
								this.processLocationHubIds = [...new Set(this.shipmentData.map(a => a.Processlocation))];
								if(this.processLocationHubIds.length > 0) {
									this.getHubNameByHubId(this.processLocationHubIds);
								}
							} else {
								this.$alertify.error(result.data.ReturnMessage)
							}
							this.isLoading=false;
						}, error => {
							this.isLoading=false;
							console.error(error)
						}
                    )
				}
			});
		},
		getHubNameByHubId(hubids) {
			this.isLoading = true;
			this.input = ({
			'facilityIds': hubids,
			});
			axios({
			method: 'post',
			url: apiUrl.api_url_hubops + 'getHubdetailsFromFMS',
			data: this.input,
			headers: {
				'Content-Type': 'application/json',
				'authorization': 'authkey xB84JJ89Hd25',
			},
			})
			.then((result) => {
				this.isLoading = false;
				if (result.data.ResultCode == 100) {
        			let facilitiesDetails = result.data.ResponseData.facilitiesDetails;

					this.updatedShipmentData = this.shipmentData.map(shipment => {
						const facility = facilitiesDetails.find(facility => facility.facilityId === shipment.Processlocation);
						if (facility) {	
							shipment.Processlocation = facility.facilityName;
						}
						return shipment;
					});

				} else {
					this.$alertify.error(result.data.ReturnMessage);
				}
			})
			.catch((error) => {
				this.isLoading = false;
				console.error(error);
			});
		},
	},
  };
  


// WEBPACK FOOTER //
// ./src/views/components/AdditionalEventLogs/DayEndClosureLogs/DayEndClosureLogs.js